const addToCart = (item, self) => {
  return new Promise( async (resolve, reject) => {
    let body = {
      "product_id": item.productId,
      "quantity": item.quantity,
    }
    if (item.modificationId) {
      body.modification_id = item.modificationId;
    }
    await self.$api.agent.transport.post(`/cart`, body).then((res) => {
      resolve({
        isSuccess: true,
        data: res.data
      })
    }).catch((err) => {
      resolve({
        isSuccess: false,
        ...err.response
      })
    })
  });
}

export {
  addToCart
}
